import { Box } from '@mui/material'
import Slider from 'react-slick'

const settings = {
    dots: true,
    infinite: true,
    speed: 400,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplaySpeed: 4000,
    autoplay: true,
    arrows: true,
    responsive: [
        {
            breakpoint: 900,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                infinite: true,
                dots: false,
                speed: 400,
                autoplay: true,
                autoplaySpeed: 4000,
                pauseOnHover: true,
                arrows: false
            }
        }
    ]
}

const box = { 
    mt: '50px', 
    width: '60%' 
}

const image = { 
    width: '100%' 
}

export default function SliderBanner () {
    return (
        <Box sx={box}>
            <Slider {...settings}>
                <Box>
                    <img src={'./assets/images/product/banner1.png'} alt="Card 1" style={image}/>
                </Box>
                <Box>
                    <img src={'./assets/images/product/banner3.png'} alt="Card 2" style={image}/>
                </Box>
                <Box>
                    <img src={'./assets/images/product/banner2.png'} alt="Card 3" style={image}/>
                </Box>
            </Slider>
        </Box>
    )
}